import { Palette } from "lucide-react";
import { defineFeature } from "../types";

/**
 * /dev/ui — the design-system showcase used for visual QA.
 *
 * The route is always registered (so a `vite preview` build can be screenshotted
 * too) but it is never advertised: the ⌘K command only appears in a dev build,
 * and nothing links to it from the product UI.
 */
export default defineFeature({
  key: "devui",
  title: "Design system",
  routes: [{ path: "dev/ui", lazy: () => import("./page") }],
  commands: import.meta.env.DEV
    ? [
        {
          key: "devui.open",
          label: "Design system showcase",
          icon: Palette,
          to: "/dev/ui",
          group: "help",
          keywords: ["components", "ui", "storybook", "styleguide", "tokens", "qa"],
          description: "Every component in light and dark, for visual QA",
        },
      ]
    : [],
});
